import * as Actions from '../../../Modules/CmsActions'

const initialState = {
  user: null,
  userSetting: null,
  loading: false,
}

const SessionReducer = (state = initialState, action) => {
  const { payload } = action
  switch (action.type) {
    case Actions.USER_SETTING:
      return userSetting(state, action.payload.site)

    case Actions.REQ_LOGIN:
      return loading(state)

    case Actions.SUCCESS_LOGIN:
      return updateUserWithLoaded(state, action.payload.user)

    case Actions.FAILURE_LOGIN:
      return loaded(state)

    case Actions.REQUEST_UPDATE_USER:
      return loading(state)

    case Actions.FINISH_UPDATE_USER:
      return payload.original
        ? updateUserWithLoaded(state, payload.original)
        : loaded(state)

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

function userSetting(state, userSetting) {
  return { ...state, userSetting }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

function updateUserWithLoaded(state, user) {
  const updated = { ...state, user }
  return loaded(updated)
}

export default SessionReducer
